import { d as _inheritsLoose, e as _assertThisInitialized, f as _defineProperty } from './chunk-fb907809.js';
import React__default, { createElement, Component } from 'react';
import { findDOMNode, createPortal } from 'react-dom';
import { theme } from 'styled-tools';
import hoistNonReactStatics from 'hoist-non-react-statics';
import styled from './styled.js';
import as from './as.js';
import Box from './Box.js';
import 'styled-components';
import '@emotion/is-prop-valid';
import 'prop-types';
import './chunk-a44fd1b3.js';
import './chunk-a7ce379e.js';

var Component$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Component$$1, _React$Component);

  function Component$$1() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      wrapper: null
    });

    return _this;
  }

  var _proto = Component$$1.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var wrapper = document.createElement("div");
    document.body.appendChild(wrapper);
    this.setState({
      wrapper: wrapper
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var wrapper = this.state.wrapper;

    if (wrapper) {
      document.body.removeChild(wrapper);
    }
  };

  _proto.render = function render() {
    var wrapper = this.state.wrapper;

    if (wrapper) {
      return createPortal(createElement(Box, this.props), wrapper);
    }

    return null;
  };

  return Component$$1;
}(Component);

hoistNonReactStatics(Component$1, Box);
var Portal = styled(Component$1).withConfig({
  displayName: "Portal",
  componentId: "sc-1anvbga-0"
})(["", ";"], theme("Portal"));
var Portal$1 = as("div")(Portal);

export default Portal$1;
